import React from 'react';

import { ProjectIssueTypesProvider } from '@qality/common-components/src/lib/ProjectIssueTypesProvider';

import { ImportTestCasesFormView } from './ImportTestCasesForm.view';

export const ImportTestCasesForm = () => {
  const initialValues = {
    encoding: 'UTF-8',
    delimiter: {
      label: ', (comma)',
      value: ',',
    },
    file: null,
    mapping: [],
  };

  return (
    <ProjectIssueTypesProvider>
      <ImportTestCasesFormView initialValues={initialValues} />
    </ProjectIssueTypesProvider>
  );
};
